import { render, staticRenderFns } from "./task_breed.vue?vue&type=template&id=a86e68e8&scoped=true"
import script from "./task_breed.vue?vue&type=script&lang=js"
export * from "./task_breed.vue?vue&type=script&lang=js"
import style0 from "./task_breed.vue?vue&type=style&index=0&id=a86e68e8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86e68e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a86e68e8')) {
      api.createRecord('a86e68e8', component.options)
    } else {
      api.reload('a86e68e8', component.options)
    }
    module.hot.accept("./task_breed.vue?vue&type=template&id=a86e68e8&scoped=true", function () {
      api.rerender('a86e68e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/grow/task_breed.vue"
export default component.exports